import {
  availableChannels,
  inboxesForChannel,
} from 'dashboard/helper/channelCatalogue';

/**
 * The Channels group: one leaf per channel type, each carrying an ON/OFF pill.
 *
 * Text.com's single best settings detail is that connection state is legible
 * from the panel without opening anything. The leaves come from the shared
 * catalogue rather than from the connected inboxes, so this group and the All
 * channels page never drift apart - and both filter it through the same
 * per-account availability gates, so a flag-disabled channel disappears from
 * the nav and the page together.
 *
 * Every available leaf points at that channel's own page, connected or not -
 * the page holds for none, one, or ten inboxes, so the nav never has to guess
 * where someone meant to go.
 */
export default ({
  t,
  accountScopedRoute,
  sortedInboxes = [],
  accountFeatures = {},
}) => ({
  name: 'Settings Channels',
  label: t('SIDEBAR.CHANNELS'),
  icon: 'i-ph-mailbox',
  defaultFolded: true,
  children: [
    {
      name: 'Settings All Channels',
      label: t('SIDEBAR.ALL_CHANNELS'),
      icon: 'i-ph-squares-four',
      activeOn: ['settings_inbox_list', 'settings_inbox_new'],
      to: accountScopedRoute('settings_inbox_list'),
    },
    ...availableChannels(accountFeatures).map(channel => ({
      name: `Settings Channel ${channel.key}`,
      label: t(channel.labelKey),
      icon: channel.icon,
      statePill: inboxesForChannel(sortedInboxes, channel.channelType).length
        ? 'on'
        : 'off',
      to: accountScopedRoute('settings_channel_show', { channel: channel.key }),
    })),
  ],
});
